import { render, staticRenderFns } from "./RequestConversations.vue?vue&type=template&id=58532a70&"
import script from "./RequestConversations.vue?vue&type=script&lang=js&"
export * from "./RequestConversations.vue?vue&type=script&lang=js&"
import style0 from "./RequestConversations.vue?vue&type=style&index=0&id=58532a70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports